import {Folder} from '../../../Assets.types';

/**
 * Immutably remove a folder from the tree
 * @param assetTree - The tree structure
 * @param folderId - ID of the folder to remove
 * @returns New tree with folder removed (null if root folder is removed)
 */
export default function removeFolderFromTree(
  assetTree: Folder | null,
  folderId: number,
): Folder | null {
  if (!assetTree) {
    return null;
  }

  // If the root folder itself is being deleted, return null
  if (assetTree.folderId === folderId) {
    return null;
  }

  function removeNestedFolder(folder: Folder): Folder {
    // Filter out the folder from this folder's children
    const filteredFolders = folder.folders?.filter((f) => f.folderId !== folderId);

    // Recursively process remaining nested folders
    const updatedFolders = filteredFolders?.map(removeNestedFolder);

    return {
      ...folder,
      folders: updatedFolders,
    };
  }

  return removeNestedFolder(assetTree);
}

